<template>
	<div>
		<vxe-modal v-model="show" width="400" title="选择物流" show-footer @confirm="submitPrice" @show="onShow">
			<template #default>
				<el-form ref="form" :model="parcelForm" label-width="80px" size="mini">
					<el-form-item label="创建时间">
						<datePicker v-model="parcelForm.createTime" type="date" readonly />

					</el-form-item>
					<el-form-item label="单据编码">
						<el-input v-model="parcelForm.billCode" readonly></el-input>
					</el-form-item>
					<el-form-item label="供应商">
						<el-input v-model="parcelForm.supplierName" readonly></el-input>
					</el-form-item>
					<el-form-item label="仓库">
						<el-input v-model="parcelForm.storageName" readonly></el-input>
					</el-form-item>
					<el-form-item label="物流方式">
						<el-select v-model="parcelForm.parcel" placeholder="请选择" @change="parcelChange" clearable>
							<el-option v-for="item in parcelOptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="到仓天数" required>
						<el-input v-model="parcelForm.getday"  @change="getdayChange" clearable></el-input>
					</el-form-item>
<!-- 					<el-form-item label="剩余天数">
						<el-input v-model="parcelForm.remainday" readonly></el-input>
					</el-form-item> -->
					<el-form-item label="预计到仓" required>
						<datePicker v-model="parcelForm.pregettime" type="date" @change="pregettimeChange" clearable />
					</el-form-item>
				</el-form>
			</template>
		</vxe-modal>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	export default {
		name: 'goodspriceIndex',
		props: {
			parcelForm: {
				type: Object,
				default: () => {
					return {
						createTime: null,
						billID: null,
						billCode: null,
						supplierID: null,
						supplierName: null,
						storageID: null,
						storageName: null,
						parcel: null,
						getday: null,
						remainday: null,
						pregettime: null,
					}
				}
			},
		},
		data() {
			return {
				show: false,
				parcelOptions: []
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			onShow() {
				this.getSupplierParcelByWarehouse()
			},
			getSupplierParcelByWarehouse() {
				let supplier = window.systemData.supplier
				let warehouse = window.systemData.warehouse
				supplier = supplier.find((item) => {
					return item.wlnid == this.parcelForm.supplierID
				})
				warehouse = warehouse.find((item) => {
					return item.wlnid == this.parcelForm.storageID
				})
				this.$api.supplier.getSupplierParcelByWarehouse({
					supplierID: supplier ? supplier.id : null,
					storageID: warehouse ? warehouse.id : null
				}).then((res) => {
					let parcelOptions = []
					res.forEach((item) => {
						parcelOptions.push({
							getday: item.getday,
							label: window.systemMethods.getEmunValue('parceltype', item.parcel),
							value: item.parcel
						})
					})
					this.parcelOptions = parcelOptions
					console.log(parcelOptions)
				})
			},
			getdayChange(e) {
				if(e){
					this.parcelForm.pregettime = e * 86400000 + this.parcelForm.createTime
				}else{
					this.parcelForm.pregettime = null
				}
				
			},
			parcelChange(e) {
				let parcel = this.parcelOptions.find((item) => {
					return item.value == e
				})
				if (parcel) {
					this.parcelForm.getday = parcel.getday
					this.parcelForm.pregettime = parcel.getday * 86400000 + this.parcelForm.createTime
				}else{
					this.parcelForm.getday = null
					this.parcelForm.pregettime = null
				}
			},
			submitPrice() {
				this.$api.wlnpurchase.updateParcel(this.parcelForm).then(() => {
					this.$emit('submit', {
						data: this.parcelForm
					})
				})

			},
			pregettimeChange(e){
				if(e){
					this.parcelForm.getday = Math.ceil((e - this.parcelForm.createTime)/(60*60*24*1000))
				}else{
					this.parcelForm.getday = null
				}
			}
		},
		components: {
			datePicker
		}
	}
</script>